import React, { useEffect, useRef, useState } from "react"
import { TableCell, Typography } from "@material-ui/core"
import { formatarCampoVazio } from '../../../shared/utils/Formatacao';
import CelulaTooltip from "./CelulaTooltip"

const TableCellTooltip = ({ itemCelula, itemTooltip, styleTableCell, styleItem, placement }) => {
	const refLinha = useRef(null)
	const [mostrarTooltip, setMostrarTooltip] = useState(false)

	useEffect(() => {
		const handleResize = () => {
			const isOverflowed = refLinha.current && refLinha.current.scrollWidth > refLinha.current.clientWidth
			if (isOverflowed) setMostrarTooltip(true)
			else setMostrarTooltip(false)
		}

		handleResize()
		window.addEventListener("resize", handleResize)

		return () => {
			window.removeEventListener("resize", handleResize)
		}
	}, [])

	return (
		<>
			<TableCell style={styleTableCell}>
				<div style={styleItem} ref={refLinha} className={"text-overflow-ellipsis"}>
					{itemCelula}
				</div>
			</TableCell>

			{mostrarTooltip ? <CelulaTooltip placement={placement ? placement : "bottom"} title={itemTooltip} /> : <TableCell />}
		</>
	)
}

const TableCellEllipsis = (props) => {
	const { text, width, height, color } = props;
	const style = { maxWidth: width };

	if (height)
		style.height = height;

	return (
		<TableCellTooltip
				itemCelula={
						<Typography
								component="span"
								color={color || "textSecondary"}
						>
								{formatarCampoVazio(text)}
						</Typography>
				}
				itemTooltip={text}
				styleTableCell={style}
		/>
	);
};

export default TableCellEllipsis
